import React from 'react';

import "./Logo.scss";


function Logo() {
  return (
    <div className="Logo">
      <span className="blue glass">
        RELAXAČNÍ DOTYK
        
      </span>

    </div>




  );
}

export default Logo;
